import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { products, merchConfig } from '../data/mock';
import { useCart } from '../context/CartContext';
import { toast } from 'sonner';

const PreOrderCard = ({ product }) => {
  const { addToCart } = useCart();
  const [selectedSize, setSelectedSize] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [showSizeChart, setShowSizeChart] = useState(false);

  const handleAddToCart = () => {
    if (!selectedSize) {
      toast.error('Please select a size');
      return;
    }

    addToCart({
      name: product.name,
      price: product.price,
      size: selectedSize,
      quantity: quantity,
      image: product.images[0],
      productId: product.id
    });

    toast.success(`Added ${quantity} ${selectedSize} ${product.color.toUpperCase()} shirt(s) to cart! Proceed to checkout.`);
    
    setSelectedSize('');
    setQuantity(1);
  };

  return (
    <div className="preorder-card">
      <div className="preorder-images-compact">
        <img src={product.images[0]} alt={`${product.name} Front`} />
        <img src={product.images[1]} alt={`${product.name} Back`} />
      </div>
      
      <div className="preorder-info-compact">
        <h3 className="preorder-product-name">{product.name}</h3>
        <p className="preorder-price">${product.price.toFixed(2)}</p>
      </div>

      <div className="preorder-form-compact">
        <div className="form-group">
          <label className="form-label">Size *</label>
          <select
            value={selectedSize}
            onChange={(e) => setSelectedSize(e.target.value)}
            className="checkout-input"
            required
          >
            <option value="">Select size</option>
            {merchConfig.availableSizes.map(size => (
              <option key={size} value={size}>{size}</option>
            ))}
          </select>
          
          <button
            type="button"
            onClick={() => setShowSizeChart(!showSizeChart)}
            style={{
              background: 'none',
              border: '1px solid #8B0000',
              color: '#8B0000',
              padding: '8px 15px',
              marginTop: '10px',
              cursor: 'pointer',
              fontSize: '14px',
              width: '100%'
            }}
          >
            {showSizeChart ? '▲ Hide Size Chart' : '▼ View Size Chart'}
          </button>

          {showSizeChart && (
            <div style={{
              marginTop: '15px',
              padding: '15px',
              background: '#0a0a0a',
              border: '1px solid #8B0000'
            }}>
              <h4 style={{ color: '#8B0000', marginBottom: '10px', fontSize: '16px' }}>
                SIZE CHART (inches)
              </h4>
              <div style={{ overflowX: 'auto' }}>
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  fontSize: '13px'
                }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid #8B0000' }}>
                      <th style={{ padding: '8px', textAlign: 'left', color: '#8B0000' }}>Size</th>
                      <th style={{ padding: '8px', textAlign: 'center', color: '#8B0000' }}>Width</th>
                      <th style={{ padding: '8px', textAlign: 'center', color: '#8B0000' }}>Length</th>
                      <th style={{ padding: '8px', textAlign: 'center', color: '#8B0000' }}>Sleeve</th>
                    </tr>
                  </thead>
                  <tbody>
                    {merchConfig.availableSizes.map(size => (
                      <tr key={size} style={{ borderBottom: '1px solid #333' }}>
                        <td style={{ padding: '8px', fontWeight: 'bold', color: '#fff' }}>{size}</td>
                        <td style={{ padding: '8px', textAlign: 'center' }}>{merchConfig.sizingChart.width[size]}"</td>
                        <td style={{ padding: '8px', textAlign: 'center' }}>{merchConfig.sizingChart.length[size]}"</td>
                        <td style={{ padding: '8px', textAlign: 'center' }}>{merchConfig.sizingChart.sleeve[size]}"</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p style={{ fontSize: '12px', color: '#999', marginTop: '10px', marginBottom: '0' }}>
                * Sleeve length measured from center back
              </p>
            </div>
          )}
        </div>

        <div className="form-group">
          <label className="form-label">Quantity *</label>
          <select
            value={quantity}
            onChange={(e) => setQuantity(Number(e.target.value))}
            className="checkout-input"
            required
          >
            {[1,2,3,4,5].map(num => (
              <option key={num} value={num}>{num}</option>
            ))}
          </select>
        </div>

        <button onClick={handleAddToCart} className="btn-add-to-cart" style={{
          width: '100%',
          padding: '15px',
          marginTop: '20px',
          background: '#8B0000',
          color: '#fff',
          border: 'none',
          fontSize: '16px',
          fontWeight: 'bold',
          cursor: 'pointer'
        }}>
          ADD TO CART
        </button>
      </div>
    </div>
  );
};

const PreOrderPage = ({ onBack }) => {
  return (
    <div className="preorder-page">
      <div className="preorder-header">
        <button onClick={onBack} className="back-button">
          <ArrowLeft size={20} />
          Back
        </button>
        <h1 className="death-metal-title" style={{ textAlign: 'center', marginBottom: '10px' }}>SHOP</h1>
        <p style={{ textAlign: 'center', color: '#999', marginBottom: '40px' }}>
          Select your design, size, and quantity - complete purchase at checkout
        </p>
      </div>

      <div className="preorder-grid-two">
        {products.map(product => (
          <PreOrderCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
};

export default PreOrderPage;
